import * as React from "react";
import { Navigation } from "../components/settings/Navigation"

export const Settings = () => {

   return <div> 
       <Navigation/>
   </div>
}